import { render, staticRenderFns } from "./choice-popup.vue?vue&type=template&id=c1c1c058&scoped=true&"
import script from "./choice-popup.vue?vue&type=script&lang=ts&"
export * from "./choice-popup.vue?vue&type=script&lang=ts&"
import style0 from "./choice-popup.vue?vue&type=style&index=0&id=c1c1c058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c1c058",
  null
  
)

export default component.exports